export const LANDING_PAGE = '/'

export const STUDENT_LOGIN_PAGE = '/student/login'
export const STUDENT_REGISTER_PAGE = '/student/register'
export const STUDENT_DASHBOARD = '/student/dashboard'
export const STUDENT_MAILBOX = '/student/mailbox'
export const STUDENT_DOCUMENTS_DASHBOARD = '/student/documents'
export const STUDENT_FORGOT_PASSWORD = '/student/forgotten-password'
export const STUDENT_RESET_PASSWORD = '/student/reset-password'
export const STUDENT_PROFILE = '/student/profile'
export const STUDENT_MISSIONS = '/student/missions'
export const STUDENT_SETTINGS = '/student/settings'
export const STUDENT_NETWORK = '/student/network'
export const STUDENT_DETAILED_MISSION = '/student/detailed-mission/:missionId'
export const STUDENT_MISSION_CHAT = '/student/mission/chat/:missionId'
export const STUDENT_PRIVATE_MESSAGE = '/student/private-chat/:userId'
export const STUDENT_STATISTICS = '/student/statistics'
export const STUDENT_PAYMENTS = '/student/payments'
export const STUDENT_GROUP = '/student/group'
export const STUDENT_CONTACT = '/student/contact'

export const AUTH_VERIFY_PWD = '/auth/verify/:code'
export const STUDENT_INVOICES_DASHBOARD = '/student/invoices'

export const COMPANY_LOGIN_PAGE = '/company/login'
export const COMPANY_REGISTER_PAGE = '/company/register'
export const COMPANY_DASHBOARD = '/company/dashboard'
export const COMPANY_MAILBOX = '/company/mailbox'
export const COMPANY_DOCUMENTS_DASHBOARD = '/company/documents'
export const COMPANY_FORGOT_PASSWORD = '/company/forgotten-password'
export const COMPANY_RESET_PASSWORD = '/company/reset-password'
export const COMPANY_INVOICES_DASHBOARD = '/company/invoices'
export const COMPANY_MISSIONS = '/company/missions'
export const COMPANY_DETAILED_MISSION = '/company/detailed-missions/:missionId'
export const COMPANY_MISSION_CHAT = '/company/mission/chat/:missionId'
export const COMPANY_PROFILE = '/company/profile'
export const COMPANY_SETTINGS = '/company/settings'
export const COMPANY_CONTACT = '/company/contact'

export const ADMIN_LOGIN_PAGE = '/admin/login'
export const ADMIN_DASHBOARD = '/admin/dashboard'
export const ADMIN_USERS_DASHBOARD = '/admin/users'
export const ADMIN_MISSIONS_DASHBOARD = '/admin/missions'
export const ADMIN_DOCUMENTS_DASHBOARD = '/admin/documents'
export const ADMIN_VERIFY_COMPANY_DOCUMENTS = '/admin/verify-company-documents'
export const ADMIN_VERIFY_STUDENT_DOCUMENTS = '/admin/verify-student-documents'
export const ADMIN_CONTACTS = '/admin/contacts'
export const ADMIN_ARCHIVES = '/admin/archives'
export const ADMIN_PAYMENTS = '/admin/payments'
export const ADMIN_TICKETS = '/admin/tickets'

export const MENTION_LEGALES = '/mention-legales'
export const CONTACT = '/contact'
export const WAIT_VERIFIED_STUDENT_ACCOUNT = '/waiting-student-account'
